// extracted by mini-css-extract-plugin
module.exports =  {"disabled":"RouterLink-module__disabled--Cc"};